<script setup></script>
<template>
    <div>
        <Header>
            <div class="top-navigation elevation-1 bg-blue-grey-darken-3">
                <v-container fluid class="d-flex align-center justify-space-between">
                    <div class="left d-flex align-center">
                        <span class="project-title text-h6">
                            <img
                                class="mx-auto mx-md-0"
                                src="https://cdn.visuado.com/visuado-logo-white-horizontal.png"
                                width="100px"
                                height="auto"
                            />
                        </span>
                    </div>
                    <div class="center d-flex justify-center align-center flex-grow-1"></div>
                </v-container>
            </div>
        </Header>
        <v-container class="content-page-wrapper">
            <slot />
        </v-container>
        <Foot><LanguageSwitcher /></Foot>
    </div>
</template>
<style scoped>
.content-page-wrapper {
    max-width: 1280px;
    margin: 0 auto;
    min-height: 90vh;
}
</style>
